module.exports = __webpack_public_path__ + "img/floor0.fcf8095d.jpg";